// Footer.js

const Footer = function() {
    return (
        <footer>
            <p>Created at <a target={"_blank"} href='https://junocollege.com/'>Juno College</a></p>
            <p>Cloud animation by: Mark Bowley</p>
        </footer>
    )
}
export default Footer